<template>
	<div class="goods-management-body">
		<div class="fx-header">
			<p>商品档案</p>
		</div>
		<search @handleSearch="handleSearch" @initPage="initPage" :auditStateShow="auditStateShow" ref="searchRef"/>
		<div class="features-btn-box">
			<el-button type="primary" size='small' class="fx-big-btn" plain @click="add" v-if="AuthorityList['02_0001_0002_00'] && (newbaseinfo === 0)">新建</el-button>
			<el-button type="primary" size='small' class="fx-big-btn" plain @click="delGoods" v-if="AuthorityList['02_0001_0003_00']">删除</el-button>
			<!-- <el-button type="primary" size='small' class="fx-big-btn" plain @click="changeSaleState(1)" v-if="AuthorityList['02_0001_0004_00']">可售</el-button>
			<el-button type="primary" size='small' class="fx-big-btn" plain @click="changeSaleState(0)" v-if="AuthorityList['02_0001_0005_00']">不可售</el-button> -->
			<el-button type="primary" size='small' class="fx-big-btn" plain @click="pull" v-if="AuthorityList['02_0001_0005_00'] && clddock === 1">拉取</el-button>
			<el-button type="primary" size='small' class="fx-big-btn" plain @click="goodStatus" v-if="AuthorityList['02_0001_0009_00']">商品状态</el-button>
			<el-button v-if="AuthorityList['02_0001_0001_00'] && auditShopCount>0" type="primary" size='small' class="fx-big-btn" plain @click="check">批量提交审核</el-button>
			<el-button v-if="tempflag === 1" type="primary" size='small' class="fx-big-btn" plain @click="getOldData">导入老数据</el-button>
			<el-button v-if="tempflag === 2" type="primary" size='small' class="fx-big-btn" plain @click="getOldData1">邀请码处理</el-button>
			<el-button v-if="tempflag === 3" type="primary" size='small' class="fx-big-btn" plain @click="getShopData">店铺类别处理</el-button>
			<label class="batch-register-btn" for="file" v-if="AuthorityList['02_0001_0006_00']">
				<i class="excel-icon import-excel-icon"/>
				<span>导入</span>
			</label>
			<input type="file" ref="file" id="file" accept=".xls" v-show="false" @change="getFile">
			<a href="javascript:void(0);" class="batch-register-btn" @click="exportExcel" v-if="AuthorityList['02_0001_0007_00']">
				<i class="excel-icon export-excel-icon"/>
				<span>导出</span>
			</a>
		</div>
		<main-table
			ref="tableRef"
			:deleteAuthority='AuthorityList["02_0001_0003_00"]'
			:viewAuthority='AuthorityList["02_0001_0008_00"] || AuthorityList["02_0001_0001_00"]'
			:totalCount='totalCount'
			:tableData='tableData'
			:auditStateShow="auditStateShow"
			@sizeChange='handleSizeChange'
			@pageChange='handlePageChange'
			@delIds='delIds'
			@saveSearch='saveSearch'
			@delSuc='getGoodsInfo'
		/>
		<el-dialog top='60px' class="pull-dialog" :visible.sync="dialogVisible" width='1200px' :close-on-click-modal="false">
			<PullDialog
				:visible.sync="dialogVisible"
				v-if="dialogVisible"
				:classData="classData"
				:itemData="itemData"
				@refresh="getGoodsInfo"
			/>
		</el-dialog>
		<el-dialog title="提示" class="detail-dialog-title excel-dialog" top='60px' :visible.sync="errorMsgModel" width='400px' :close-on-click-modal="false">
			<div style="margin-bottom:10px;max-height:250px;overflow:auto">
				<div class="errormsgText" v-for="(item,index) in errorMsgList" :key='index' >
					{{item}}
				</div>
			</div>
			<div style="width:100%;text-align: center;margin-top:10px">
				<el-button size="small" style="width:120px" plain type="primary" @click="errorMsgClick">确认</el-button>
			</div>
		</el-dialog>
		<el-dialog class="pull-dialog" :visible.sync="goodStatusShow" width='400px' :close-on-click-modal="false">
			<goodStatus
				:ids='ids'
				:show='goodStatusShow'
				@close='closeGoodStatus'
				@reload='getGoodsInfo'></goodStatus>
		</el-dialog>
	</div>
</template>

<script>
import Search from '@/components/goodsManagement/Search.vue'
import MainTable from '@/components/goodsManagement/MainTable.vue'
import PullDialog from '@/components/goodsManagement/PullDialog.vue'
import goodStatus from '@/components/goodsManagement/goodStatus.vue'
export default {
	name: 'goodsManagement',
	data () {
		return {
			goodStatusShow: false,
			AuthorityList: {
				'02_0001_0001_00': false,
				'02_0001_0002_00': false,
				'02_0001_0003_00': false,
				'02_0001_0004_00': false,
				'02_0001_0005_00': false,
				'02_0001_0006_00': false,
				'02_0001_0007_00': false,
				'02_0001_0008_00': false,
				'02_0001_0009_00': false
			},
			bcId: '0',
			scId: '0',
			goodsName: '',
			saleState: 2,
			auditState: 4,
			sourceflag: -1,
			unitFlag: -1,
			page: 1,
			size: 20,
			totalCount: 0,
			tableData: [],
			ids: [],
			auditStateShow: 0,
			goodstableData: [],
			dialogVisible: false,
			confirmVisible: false,
			tableHeight: 300,
			number: 1,
			selectedArr: [],
			clddock: 1,
			hiddenFlag: -1,
			tempflag: null,
			auditShopCount: null,
			newbaseinfo: 1,
			classData: [],
			itemData: {},
			dbName: '',
			cldPullFlag: 0,
			errorMsgModel: false,
			errorMsgList: [],
			excelParams: {},
			bigcategoryview: 0
		}
	},
	components: {
		Search,
		MainTable,
		goodStatus,
		PullDialog
	},
	created () {
		this.getAuthority('02_0001_0000_00')
		let a = window.sessionStorage.getItem('goodsInfo')
		if (a) {

		} else {
			this.getGoodsInfo()
		}
		this.getAuditShopCount()
	},
	methods: {
		closeGoodStatus () {
			this.goodStatusShow = false
		},
		goodStatus () {
			if (this.ids.length < 1) {
				this.$message.error('请勾选商品！')
				return false
			} else {
				this.goodStatusShow = true
			}
		},
		initPage () {
			this.$refs.tableRef.initPage()
		},
		errorMsgClick () {
			this.errorMsgModel = false
		},
		getFile (e) {
			this.uploadExcelHandle()
			this.$refs.file.value = ''
		},
		uploadExcelHandle () {
			return new Promise((resolve, reject) => {
				var formData = new FormData()
				formData.append('file', this.$refs.file.files[0])
				this.$store.dispatch('requestFilePost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/goods/importExcel`,
					data: formData
				}).then(res => {
					if (res.result) {
						this.getAuditShopCount()
						this.getGoodsInfo()
						this.$message.success('导入成功！')
					} else {
						this.errorMsgList = res.data
						this.errorMsgModel = true
					}
				})
			})
		},
		exportExcel () {
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.urlQIV}/shop/goods/exportExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			this.excelParams.ids = this.ids.join(',')
			req.send(JSON.stringify(this.excelParams))
		},
		download (blobUrl) {
			let curDate = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
			const a = document.createElement('a')
			a.style.display = 'none'
			a.download = '商品档案(' + curDate + ').xls'
			a.href = blobUrl
			a.click()
		},
		getOldData1 () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/dealOldDataQC`
			}).then(res => {})
		},
		getOldData () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQNVShop}/goods/test`
			}).then(res => {})
		},
		getShopData () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/dealOldShopCategory`
			}).then(res => {})
		},
		saveSearch (data) {
			let info = {
				goodsName: this.goodsName,
				bcId: this.bcId,
				scId: this.scId,
				saleState: this.saleState,
				auditState: this.auditState,
				unitFlag: this.unitFlag,
				sourceflag: this.sourceflag,
				hiddenFlag: this.hiddenFlag,
				scrollTopValue: data.scrollTopValue,
				size: data.size,
				page: data.page
			}
			let a = JSON.stringify(info)
			window.sessionStorage.setItem('goodsInfo', a)
			this.$router.push('goodsAttributes')
		},
		check () {
			if (this.ids.length < 1) {
				this.$message.error('请至少选择一个商品！')
				return false
			}
			this.$confirm('提交审核，是否继续？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let a = this.ids.join(',')
				let params = {
					ids: a
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/goods/saveOrUpdateProductBase`,
					data: params
				}).then(res => {
					if (res.result) {
						this.$message.success('申请审核成功！')
						this.getGoodsInfo()
					} else {
						this.$message.error('申请审核失败！')
					}
				})
			}).catch(() => {})
		},
		getGoodsInfo () {
			let goodsInfoStr = window.sessionStorage.getItem('goodsInfo')
			if (goodsInfoStr) {
				this.page = JSON.parse(goodsInfoStr).page
				this.size = JSON.parse(goodsInfoStr).size
			}
			let params = {
				id: '0',
				bcId: this.bcId,
				scId: this.scId,
				goodsName: this.goodsName,
				saleState: this.saleState,
				auditState: this.auditState,
				page: this.page,
				size: this.size,
				order: 0,
				orderKey: 'g.createdate',
				sourceflag: this.sourceflag,
				hiddenFlag: this.hiddenFlag,
				unitFlag: this.unitFlag
			}
			let excelParams = {
				bcId: this.bcId,
				scId: this.scId,
				goodsName: this.goodsName,
				saleState: this.saleState,
				auditState: this.auditState,
				sourceflag: this.sourceflag,
				hiddenFlag: this.hiddenFlag,
				unitFlag: this.unitFlag
			}
			this.excelParams = excelParams
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getGoodsInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.totalCount = res.data.recordCount
					this.tableData = res.data.recordList === null ? [] : res.data.recordList
					this.clddock = res.data.clddock
					this.auditShopCount = res.data.auditShopCount
					this.newbaseinfo = res.data.newbaseinfo
					this.tempflag = res.data.tempflag
					this.tableData.forEach(item => {
						item.sourceflag = item.sourceflag ? '云供应链' : '新建'
					})
				}
			})
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		handleSearch (value) {
			this.page = 1
			this.goodsName = value.goodsName
			this.bcId = value.bcId
			this.scId = value.scId
			this.saleState = value.saleState
			this.auditState = value.auditState
			this.unitFlag = +value.unitFlag
			this.sourceflag = +value.sourceflag
			this.hiddenFlag = +value.hiddenFlag
			this.getGoodsInfo()
		},
		handleSizeChange (value) {
			this.size = value
			this.getGoodsInfo()
		},
		handlePageChange (value) {
			this.page = value
			this.getGoodsInfo()
		},
		add () {
			window.sessionStorage.removeItem('goodsid')
			window.sessionStorage.setItem('goodsAdd', true)
			this.$router.push('goodsAttributes')
		},
		delIds (data) {
			this.ids = data
		},
		delGoods () {
			if (this.ids.length < 1) {
				this.$message.error('请至少选择一个商品！')
				return false
			}
			this.$confirm('是否删除商品？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					ids: '' + this.ids
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/goods/delGoods`,
					data: params
				}).then(res => {
					if (res.result) {
						this.$message.success('删除成功！')
						this.getGoodsInfo()
					} else {
						this.$message.error(res.msg)
						this.getGoodsInfo()
					}
				})
			}).catch(() => {})
		},
		changeSaleState (value) {
			if (this.ids.length < 1) {
				this.$message.error('请至少选择一个商品！')
				return false
			}
			if (value === 1) {
				this.changeSaleStatePost(value)
			} else {
				this.$confirm('修改后商城中商品变为不可售状态，是否继续？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.changeSaleStatePost(value)
				}).catch(() => {})
			}
		},
		changeSaleStatePost (value) {
			let tipsMsg = ''
			if (value === 1) {
				tipsMsg = '商品已可售!'
			} else {
				tipsMsg = '商品已不可售!'
			}
			let params = {
				saleState: value,
				ids: '' + this.ids
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/updateGoodsSaleState`,
				data: params
			}).then(res => {
				if (res.result === true) {
					console.log(res)
					this.$message.success(tipsMsg)
					this.getGoodsInfo()
				}
			})
		},
		getAuditShopCount () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getAuditShopCount`
			}).then(res => {
				if (res.result) {
					this.auditStateShow = res.data.auditShopCount > 0 ? 1 : 0
				}
			})
		},
		pull () {
			this.dialogVisible = true
			// let params = {}
			// this.$store.dispatch('requestPost', {
			// 	url: `${this.$fxBaseApi.urlQIVShop}/match/getWDTGoodsCategoryInfo`,
			// 	data: params
			// }).then(res => {
			// 	if (res.result) {
			// 		console.log(res.data)
			// 		this.classData = res.data
			// 		this.dialogVisible = true
			// 	} else {
			// 		this.$message.error(res.msg)
			// 	}
			// })
		},
		selectionChangeHandle (data) {
			this.selectedArr = []
			this.selectedArr = data
		},
		cancel () {
			this.confirmVisible = false
			this.dialogVisible = true
		},
		confirm () {
			if (this.selectedArr.length < 1) {
				this.$message.error('请至少选择一个商品！')
				return false
			}
			this.selectedArr.forEach(item => {
				item.enableFlag = item.enableFlag ? 1 : 0
			})
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/dockcld/synchronizeGoodsStopFlag`,
				data: this.selectedArr
			}).then(res => {
				if (res.result) {
					this.$message.success('同步商城状态成功')
					this.confirmVisible = false
					this.dialogVisible = true
				} else {
					this.$message.error(res.msg)
				}
			}).catch((e) => {
				this.$message.error(e.msg)
			})
		},
		handleClose () {
			this.dialogVisible = true
		}
	}
}
</script>

<style lang="stylus" scoped>
.goods-management-body {
	display: flex;
	min-width: 730px;
	width: 100%;
	flex-direction: column;
	height: 100%;
	.errormsgText{
		width:100%;
		text-align :left
		padding: 4px 0;
	}
	.features-btn-box {
		text-align left
		padding 20px 0
		box-sizing border-box
		border-top: 1px solid #dce2fd;
		display: flex;
		.batch-register-btn{
			cursor :pointer;
			color: var(--fx-primary-color);
			font-size: 12px;
			margin-left: 10px;
						display: flex;
						width: 80px;
						height: 32px;
						justify-content center;
						align-items center;
		}
		.excel-icon {
			display inline-block
			height 20px
			width 20px
			background-repeat no-repeat
			background-position center
			&.import-excel-icon {
				background-image: url('~images/icon/import-excel-icon.png')
			}
			&.export-excel-icon {
				background-image: url('~images/icon/export-excel-icon.png')
			}
		}
	}
}
</style>
<style lang="stylus">
.goods-management-body {
	.el-dialog__body {
		padding-top: 10px
		padding-bottom: 10px
	}
	.dialog-title {
		text-align: left
	}
	.pull-dialog {
		.el-dialog__header {
			display: none
		}
		.el-dialog__title {
			padding-left 10px
			border: none
		}
	}
		.excel-dialog {
				.el-dialog__header {
			text-align: left;
		}
		}
	.confirm-dialog {
		text-align left
		.el-dialog {
			.btn-box {
				margin-top 15px;
				display flex
				justify-content center
				.btn {
					width: 120px;
				}
			}
		}
		.confirm-dialog-container {
			height: 400px;
			display flex
			flex-direction column
			.main-table {
				margin-top 10px;
				display flex
				flex: 1
				height: 100%;
				flex-direction: column
				padding-bottom 10px;
				.main-table-box {
					flex: 1
					margin-bottom 10px;
					// overflow-y: auto;
				}
			}
		}
	}
}
</style>
